<template>
    <new-address-form-base :countries="countries">
        <template slot-scope="{ setNewAddressType, address, errors, create }">
            <form class="w-full max-w-lg mt-6">

                <div class="flex flex-wrap -mx-3 mb-6">
                    <div class="w-full px-3">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                               for="address-name">
                            {{ __('Cím elnevezése') }}
                        </label>
                        <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="address-name"
                            v-model="address.name"
                            type="text">

                        <form-error
                            field="name"
                            :errors="errors"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap -mx-3 mb-6">
                    <div class="w-full px-3">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                               for="billing-name">
                            {{ __('Billing name') }}
                        </label>
                        <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="billing-name"
                            v-model="address.billingName"
                            type="text">

                        <form-error
                            field="billingName"
                            :errors="errors"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap -mx-3 mb-6">
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                               for="address-country">
                            {{ __('Ország') }}
                        </label>
                        <div class="relative">
                            <select
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                id="address-country"
                                v-model="address.countryId">
                                <option
                                    v-for="country in countries"
                                    :key="country.id"
                                    :value="country.id"
                                    :selected="isSelectedCountry(address, country)"
                                >
                                    {{ country.name }}
                                </option>
                            </select>
                            <form-error
                                field="countryId"
                                :errors="errors"
                            />
                            <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 20 20">
                                    <path
                                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                               for="checkout_shipping_city">
                            {{ __('Város') }}
                        </label>
                        <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="checkout_shipping_city"
                            v-model="address.city"
                            type="text"
                            autocomplete="shipping_city">
                        <form-error
                            field="city"
                            :errors="errors"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap -mx-3 mb-6">
                    <div class="w-full px-3">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                               for="address-street">
                            {{ __('Utca/Út/Tér STB.') }}
                        </label>
                        <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="address-street"
                            v-model="address.street"
                            type="text">

                        <form-error
                            field="street"
                            :errors="errors"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap -mx-3 mb-6">
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                               for="address-house-number">
                            {{ __('Házszám') }}
                        </label>
                        <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="address-house-number"
                            v-model="address.houseNumber"
                            type="text"
                            autocomplete="shipping_house_number">
                        <form-error
                            field="houseNumber"
                            :errors="errors"
                        />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                               for="address-zip">
                            {{ __('Irányítószám') }}
                        </label>
                        <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="address-zip"
                            v-model="address.postCode"
                            type="text"
                            autocomplete="shipping_zip">
                        <form-error
                            field="postCode"
                            :errors="errors"
                        />
                    </div>
                </div>
                <div v-if="address.countryId && countries[countries.findIndex(c => c.id === address.countryId)].code == 'HU'" class="flex flex-wrap -mx-3 mb-6">
                    <div class="w-full px-3">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                               for="billing-tax-number">
                            {{ __('Adószám') }}
                        </label>
                        <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="billing-tax-number"
                            v-model="address.taxNumber"
                            type="text">

                        <form-error
                            field="taxNumber"
                            :errors="errors"
                        />
                    </div>
                </div>
                <div class="flex justify-center items-center">
                    <button class="region-button mt-5" type="button"
                            @click="createBillingAddress(setNewAddressType, create)">
                        {{ __('Mentés') }}
                    </button>
                </div>
            </form>
        </template>
    </new-address-form-base>
</template>

<script>
export default {
    name: 'NewBillingAddressForm',
    props: {
        countries: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            postalCode: null,
            city: null,
            customerType: null
        }
    },

    methods: {
        async createBillingAddress(setAddressType, create) {
            setAddressType('billing')
            const address = await create()

            if (address) {
                this.$emit('created', address)
            }
        },

        isSelectedCountry(address, country) {
            if (!address.countryId) {
                address.countryId = country.id
            }

            return address.countryId === country.id
        }
    }
}
</script>
